import { render } from "./Img.vue?vue&type=template&id=bada5682"
import script from "./Img.vue?vue&type=script&lang=js"
export * from "./Img.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__